module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "data-logger",
    class: {
      'logger-absolute': _vm.toggle, 'logger-inline': !_vm.toggle
    }
  }, [_c('header', [_c('button', {
    domProps: {
      "textContent": _vm._s(_vm.loggerTitle)
    },
    on: {
      "click": function($event) {
        _vm.toggleLogger()
      }
    }
  }), (_vm.toggle) ? _c('span', [_c('button', {
    domProps: {
      "textContent": _vm._s('Paste Object to console')
    },
    on: {
      "click": function($event) {
        _vm.pasteToConsole()
      }
    }
  }), _c('button', {
    domProps: {
      "textContent": _vm._s('Paste Json to console')
    },
    on: {
      "click": function($event) {
        _vm.pasteToConsoleInJson()
      }
    }
  })]) : _vm._e()]), (_vm.toggle) ? _c('article', [_c('small', {
    domProps: {
      "textContent": _vm._s(_vm.dataLength)
    }
  }), _c('pre', {
    domProps: {
      "textContent": _vm._s(_vm.data)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e9c8c66!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/DataLogger.vue
// module id = 352
// module chunks = 1